import React from 'react';

import { useSelector } from 'react-redux';
import {
  Container,
  FishContent,
  TitleContent,
  ButtonViewTasks,
  ContentOrder,
  Content,
} from './styles';
import { history } from '../../store';

function OrderDispatched() {
  const companySource = useSelector(state => state.company.data.source);
  const task_responsibility = useSelector(state => state.task.task_responsibility);
  return (
    <Container>
      <Content>
        <FishContent taskResp={task_responsibility === 2 && task_responsibility} />
        <TitleContent>
          {task_responsibility && task_responsibility === 2
            ? 'Tudo Certo!'
            : 'Seu pedido foi enviado!'}
        </TitleContent>
        <ContentOrder>
          {task_responsibility && task_responsibility === 2
            ? 'Verificamos que esse serviço é de responsabilidade do seu proprietário. Iremos contatá-lo e em breve você receberá um orçamento já aprovado por ele!'
            : 'Fique ligado! Em breve, você vai receber orçamentos dos profissionais Triider. Se preferir, baixe o aplicativo para receber notificações sobre o serviço e ter todas as facilidades do Triider na palma da sua mão.'}
        </ContentOrder>
        <ButtonViewTasks
          type="button"
          onClick={() => history.push(`/partner/${companySource || 'triider'}`)}
        >
          {task_responsibility && task_responsibility === 2 ? 'Entendi' : 'Ver meus pedidos'}
        </ButtonViewTasks>
      </Content>
    </Container>
  );
}

export default OrderDispatched;
